import * as requestFromServer from "./Crud";
import {Slice, callTypes} from "./Slice";
import { NotificationManager } from "react-notifications";

const {actions} = Slice;

export const getContestForRP = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getContestForRPList(queryParams)
    .then(response => {   
      const totalCount = response.count;
      const entities = response.list;      
      dispatch(actions.contestForRPFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
